import { render, staticRenderFns } from "./CanpayCrew.vue?vue&type=template&id=093d2684&scoped=true&"
import script from "./CanpayCrew.vue?vue&type=script&lang=js&"
export * from "./CanpayCrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d2684",
  null
  
)

export default component.exports